import * as types from "../actions/types/account.types";
import * as signuptypes from "../actions/types/onboarding.types";
import StateData from "../../assets/json/state-region.json";
import { getState, setState } from "../../utils/localStorage";
import { getValueFromEnum } from "../../utils/accessLevelEnum";
import { getIDFromEnum, signatoryStatusEnum } from "../../utils/allEnums";

const idleState = {
    state: "idle",
    isRetry: false,
    accountBalance: {},
    freeTransferCount: 0,
    dailyTransferVolume: {},
    transferLimitSettings: {},
    fetchDailyTransferVolumeLoading: "idle",
    fetchTransferLimitSettingsLoading: "idle",
    errorMessage: "",
    accountState: "idle",
    errorModal: false,
    createAccErrorMsg: "",
    toggleBalance: false,
    fetchUserInfoState: "idle",
    smeUserProfilesList: [],
    addSignatoryState: "idle",
    addSignatoryObj: {},
    stateList: StateData,
    stateObj: {},
    LGA: "",
    city: "",
    updateSmeProfileStatus: "idle",
    updateSmeBusinessAddressStatus: "idle",
    currentStep: 1,
    showAddress: false,
    showPhone: false,
    showKin: false,
    showCompanyProfile: false,
    singleSmeAccount: {
        accountNumber: "",
        cacNumber: "",
        customerId: "",
        customerCategory: null,
        registeredBusinessName: "",
        cacNumberPlaceholder: "",
        businessNamePlaceholder: "",
        tinNumber: "",
        industry: "",
        dateOfRegistration: "",
        businessInformation: 0,
        mayb: 0,
        additionalDocuments: 0,
        businessOwnerConsent: 0,
        signatoryAddress: 0,
        businessPhoneNumber: null,
        businessCategory: null,
        businessLogoFileUrl: null,
        cacRegistrationFormFileUrl: null,
        certificateOfIncorperationFileUrl: null,
        city: null,
        country: null,
        email: "",
        isMigrated: false,
        isRequestingSignatoryPINSet: false,
        lga: null,
        memorandumAndArticlesOfAssociationFileUrl: null,
        boardResolutionFileUrl: "",
        particularsOfDirectorsFileUrl: null,
        particularsOfShareHoldersFileUrl: null,
        primaryPhoneNumber: "",
        isCreatingAccStarted: false,
        isCreatingAccSuccess: false,
        isCreatingAccFailed: false,
        scumlDoc: "",
        cacFileUploaded: "",
        scumlBusinessType: "",
        directorRequired: false,
        isDirectorIndeminityAgreed: false,
        kudaBusinessTier: "",
        isBVNSubmitted: false,
        isBVNVerified: false,
        isDocumentSubmitted: false,
        isDocumentVerified: false,
        nerveID: "",
        restoreID: "",
        gender: "",
        creationDate: "",
        passport: "",
        userPhotoLinkHash: "",
        bvnStatus: "",
        idStatus: "",
        docs: {
            CertificateOfIncorperation: null,
            MemorandumAndArticlesOfAssociation: null,
            ParticularsOfDirectors: null,
            ParticularsOfShareHolders: null,
            CACRegistrationForm: null,
            SingleDocument: null,
            UtilityBill: null,
            TinCertificate: null,
            ScumlBusinessDocument: null,
        },
        signatory: {
            smeProfileID: "",
            signatoryID: "",
            firstName: "",
            middleName: "",
            lastName: "",
            dateOfBirth: "",
            phoneNumber: "",
            userID: "",
            roleID: "",
            status: null,
            isPrimarySignatory: false,
            profileImageFileUrl: "",
            isPinSet: false,
            isOnboarded: false,
        },
        user: {
            profileImageFileUrl: "",
            docs: {
                IdFront: "",
                IdBack: "",
            },
        },
        nextOfKin: {
            firstName: "",
            lastName: "",
            email: "",
            address: "",
            phoneNumber: "",
            relationship: "",
        },
        accountType: "",
        businessDetails: "",
        tin: "",
        businessDoc: "",
        cacDone: "",
        requiredDocDone: "",
        isOnboardedOpenApi: false,
        businessBvn: "",
    },
    limitedDocsState: "idle",
    limitedDocsErrorMsg: null,
    limitedDocsSuccessMsg: "",
    loadingShowBar: false,
    failedShowBar: false,
    uploadPhotoState: "idle",
    profilePhoto: "",
    singleSignatoryInfo: {},
    updateSignatoryState: "idle",
    isGetToKnowYouDone: false,
    createKudaAccountState: "idle",
    isDocsUpload: false,
    homeState: "idle",
    refreshAccBalanceState: "idle",
    approveIndemnityLoading: false,
    approveIndemnityStatus: "idle",
    showIndemnityModal: false,
    validateUserPhoneNumber: "",
    validateBusinessEmail: "",
    showStartBankingModal: false,
    utilityBillUploadState: "idle",
    localIpAddress: {
        ip: null,
        geolocation: null,
    },
    gettingStartedDashboardChecks: {
        isBusinessTypeDone: false,
        isBusinessVerifiedDone: false,
        isBusinessDocumentUploadedDone: false,
        isBusinessDetailsDone: false,
        isBusinessAddressDone: false,
        isBusinessTransactionPinDone: false,
        enableAddSignatories: false,
    },
    showTransactionPinModal: false,
    auditLogData: {},
    termsAgreed: false,
    fetchBalanceFirestore: "idle",
    rawData: {},
};

export const accountsReducer = (state = idleState, action) => {
    switch (action.type) {
        case types.FETCH_ACC_BALANCE_STARTED:
            return {
                ...state,
                accountState: "loading",
                errorModal: false,
                homeState: "loading",
            };
        case signuptypes.FETCH_SME_PROFILES_STARTED:
            return {
                ...state,
                accountState: "loading",
                errorModal: false,
                homeState: "loading",
                accountBalance: {},
            };
        case types.FETCH_ACC_BALANCE_STARTED_FIRESTORE:
            return {
                ...state,
                fetchBalanceFirestore: "loading",
            };
        case types.FETCH_ACC_BALANCE_SUCCEDEED:
            return {
                ...state,
                accountBalance: { ...state.accountBalance, ...action.payload.data },
                accountState: "success",
                errorModal: false,
                homeState: "success",
                fetchBalanceFirestore: "success",
            };
        case types.FETCH_ACC_BALANCE_FAILED:
            return {
                ...state,
                errorMessage: action.payload.message,
                accountState: "failed",
                errorModal: true,
            };
        case types.FETCH_DAILY_TRANSACTION_VOLUME_LOADING:
            return {
                ...state,
                fetchDailyTransferVolumeLoading: "loading",
            };

        case types.FETCH_DAILY_TRANSACTION_VOLUME_SUCCEEDED:
            return {
                ...state,
                dailyTransferVolume: action.payload,
                fetchDailyTransferVolumeLoading: "success",
            };

        case types.FETCH_DAILY_TRANSACTION_VOLUME_FAILED:
            return {
                ...state,
                fetchDailyTransferVolumeLoading: "failed",
            };

        case types.FETCH_TRANSACTION_LIMIT_LOADING:
            return {
                ...state,
                fetchTransferLimitSettingsLoading: "loading",
            };

        case types.FETCH_TRANSACTION_LIMIT_SUCCEEDED:
            return {
                ...state,
                transferLimitSettings: action.payload,
                fetchTransferLimitSettingsLoading: "success",
            };

        case types.FETCH_TRANSACTION_LIMIT_FAILED:
            return {
                ...state,
                fetchTransferLimitSettingsLoading: "failed",
            };

        case types.REFRESH_PAYMENT_BALANCE_STARTED:
            return {
                ...state,
                refreshAccBalanceState: "loading",
                errorModal: false,
                homeState: "idle",
            };
        case types.REFRESH_PAYMENT_BALANCE_SUCCESS:
            return {
                ...state,
                accountBalance: { ...state.accountBalance, ...action.payload.data },
                refreshAccBalanceState: "success",
                errorModal: false,
                homeState: "idle",
                fetchBalanceFirestore: "success",
            };
        case types.REFRESH_PAYMENT_BALANCE_FAILED:
            return {
                ...state,
                refreshAccBalanceState: "failed",
                errorModal: true,
            };
        case types.HIDE_ERROR_MODAL:
            return {
                ...state,
                errorModal: false,
            };
        case types.TOGGLE_BALANCE_DISPLAY:
            return {
                ...state,
                toggleBalance: !state.toggleBalance,
            };
        case types.FETCH_USER_INFO_STARTED:
            return {
                ...state,
                fetchUserInfoState: "fetching",
            };
        case types.FETCH_USER_INFO_SUCEEDED:
            return {
                ...state,
                fetchUserInfoState: "succedeed",
                smeUserProfile: [...state.smeUserProfilesList, action.payload.data],
            };
        case types.FETCH_USER_INFO_FAILED:
            return {
                ...state,
                fetchUserInfoState: "failed",
            };
        case types.ADD_SIGNATORY_STARTED:
            return {
                ...state,
                addSignatoryState: "loading",
            };
        case types.ADD_SIGNATORY_SUCCEEDED:
            return {
                ...state,
                addSignatoryState: "succedeed",
            };
        case types.ADD_SIGNATORY_FAILED:
            return {
                ...state,
                addSignatoryState: "failed",
            };
        case types.SET_SIGNATORY_OBJ:
            const { key, value } = action.payload;
            return {
                ...state,
                addSignatoryObj: {
                    ...state.addSignatoryObj,
                    [key]: value,
                },
            };
        case types.SET_STATE_DATA:
            return {
                ...state,
                stateObj: state.stateList.find((o) => o.name === action.payload),
            };
        case types.SET_LGA:
            return {
                ...state,
                LGA: action.payload,
            };
        case types.UPDATE_SME_PROFILE_STARTED:
            return {
                ...state,
                updateSmeProfileStatus: "loading",
            };
        case types.UPDATE_SME_PROFILE_SUCCEEDED:
            return {
                ...state,
                updateSmeProfileStatus: "success",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    email: action.payload.email,
                    city: action.payload.city,
                    street: action.payload.street,
                    state: action.payload.state,
                    industry: action.payload.industry,
                    country: action.payload.country,
                    lga: action.payload.lga,
                    primaryPhoneNumber: action.payload.primaryPhoneNumber,
                    tradingName: action.payload.tradingName,
                    dateOfIncorporation: action.payload.dateOfIncorporation,
                    websiteUrl: action.payload.websiteUrl,
                    landmark: action.payload.landmark,
                    monthlyTurnOver: action.payload.monthlyTurnOver,
                    numberOfTransactionsPerMonth: action.payload.numberOfTransactionsPerMonth,
                    isPubliclyTraded: action.payload.isPubliclyTraded,
                    industryType: action.payload.industryType,
                    signatory: {
                        ...state.singleSmeAccount.signatory,
                        phoneNumber: action.payload.primaryPhoneNumber,
                    },
                },
            };
        case types.UPDATE_SME_PROFILE_FAILED:
            return {
                ...state,
                updateSmeProfileStatus: "failed",
            };

        case types.UPDATE_SME_BUSINESS_ADDRESS_STARTED:
            return {
                ...state,
                updateSmeBusinessAddressStatus: "loading",
            };
        case types.UPDATE_SME_BUSINESS_ADDRESS_SUCCEEDED:
            return {
                ...state,
                updateSmeBusinessAddressStatus: "success",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    city: action.payload.city,
                    country: action.payload.country,
                    landmark: action.payload.landmark,
                    lga: action.payload.lga,
                    street: action.payload.street,
                    state: action.payload.state,
                    utilityBillFileUrl: action.payload.utilityBillFileUrl,
                },
            };
        case types.UPDATE_SME_BUSINESS_ADDRESS_FAILED:
            return {
                ...state,
                updateSmeBusinessAddressStatus: "failed",
            };
        case types.SET_GET_TO_KNOW_YOU:
            return {
                ...state,
                isGetToKnowYouDone: true,
            };
        case types.INCREASE_STEP:
            return {
                ...state,
                currentStep: action.payload,
            };
        case types.SHOW_PHONE_COMPONENT:
            return {
                ...state,
                showPhone: true,
                showAddress: false,
                showKin: false,
                showCompanyProfile: false,
            };
        case types.SHOW_ADDRESS_COMPONENT:
            return {
                ...state,
                showAddress: true,
                showPhone: false,
                showKin: false,
                showCompanyProfile: false,
            };
        case types.SHOW_KIN_COMPONENT:
            return {
                ...state,
                showKin: true,
                showAddress: true,
                showPhone: false,
                showCompanyProfile: false,
            };
        case types.SHOW_COMPANY_PROFILE_COMPONENT:
            return {
                ...state,
                showCompanyProfile: true,
                showAddress: true,
                showPhone: false,
                showKin: false,
            };
        case types.RESET_STEPS:
            return {
                ...state,
                showCompanyProfile: false,
                showAddress: true,
                showPhone: false,
                showKin: false,
            };
        case types.CREATE_WITH_ACC_INFO_START:
            return {
                ...state,
                isCreatingAccStarted: true,
                isCreatingAccFailed: false,
                isCreatingAccSuccess: false,
            };
        case types.CREATE_WITH_ACC_INFO_SUCCESS:
            const prevLocalStorage = getState();
            setState({
                ...prevLocalStorage,
                accountNumber: action.payload.data.accountNumber,
                cacNumber: action.payload.data.cacNumber,
                registeredBusinessName: action.payload.data.registeredBusinessName,
                tinNumber: action.payload.data.tinNumber,
                industry: action.payload.data.industry,
                dateOfRegistration: action.payload.data.dateOfRegistration,
                businessCategory: action.payload.data.businessCategory,
                email: action.payload.others.email,
                primaryPhoneNumber: action.payload.others.primaryPhoneNumber,
                address: action.payload.others.address,
                city: action.payload.others.city,
                country: action.payload.others.country,
                lga: action.payload.others.lga,
                docs: {
                    CertificateOfIncorperation: null,
                    MemorandumAndArticlesOfAssociation: null,
                    ParticularsOfDirectors: null,
                    ParticularsOfShareHolders: null,
                    boardResolutionFileUrl: "",
                    ScumlBusinessDocument: "",
                },
                signatory: {
                    smeProfileID: action.payload.smeProfileID,
                    id: action.payload.signatoryID,
                    firstName: action.payload.data.signatory.firstName,
                    middleName: action.payload.data.signatory.middleName,
                    lastName: action.payload.data.signatory.lastName,
                    dateOfBirth: action.payload.data.signatory.dateOfBirth,
                    phoneNumber: action.payload.data.signatory.phoneNumber,
                    userID: action.payload.data.signatory.userID,
                    accessLevel: action.payload.data.signatory.accessLevel,
                    status: action.payload.data.signatory.status,
                    isPrimarySignatory: true,
                    address: action.payload.data.signatory.address,
                },
                businessLogoFileUrl: null,
                certificateOfIncorperationFileUrl: null,
                isMigrated: true,
                isRequestingSignatoryPINSet: false,
                memorandumAndArticlesOfAssociationFileUrl: null,
                particularsOfDirectorsFileUrl: null,
                particularsOfShareHoldersFileUrl: null,
                boardResolutionFileUrl: "",
                isBusinessVerified: action.payload.data.isBusinessVerified,
            });
            return {
                ...state,
                isCreatingAccStarted: false,
                isCreatingAccSuccess: true,
                isCreatingAccFailed: false,
                user: {
                    ...state.user,
                    smeProfileID: action.payload.smeProfileID,
                    signatoryID: action.payload.signatoryID,
                },
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    accountNumber: action.payload.data.accountNumber,
                    address: action.payload.others.address,
                    cacNumber: action.payload.data.cacNumber,
                    registeredBusinessName: action.payload.data.registeredBusinessName,
                    tinNumber: action.payload.data.tinNumber,
                    industry: action.payload.data.industry,
                    dateOfRegistration: action.payload.data.dateOfRegistration,
                    boardResolutionFileUrl: "",
                    businessCategory: action.payload.data.businessCategory,
                    businessLogoFileUrl: null,
                    certificateOfIncorperationFileUrl: null,
                    city: action.payload.others.city,
                    country: action.payload.others.country,
                    email: action.payload.others.email,
                    isMigrated: true,
                    isRequestingSignatoryPINSet: false,
                    lga: action.payload.others.lga,
                    memorandumAndArticlesOfAssociationFileUrl: null,
                    particularsOfDirectorsFileUrl: null,
                    particularsOfShareHoldersFileUrl: null,
                    primaryPhoneNumber: action.payload.others.primaryPhoneNumber,
                    signatory: {
                        smeProfileID: action.payload.smeProfileID,
                        id: action.payload.signatoryID,
                        firstName: action.payload.data.signatory.firstName,
                        middleName: action.payload.data.signatory.middleName,
                        lastName: action.payload.data.signatory.lastName,
                        dateOfBirth: action.payload.data.signatory.dateOfBirth,
                        phoneNumber: action.payload.data.signatory.phoneNumber,
                        userID: action.payload.data.signatory.userID,
                        accessLevel: action.payload.data.signatory.accessLevel,
                        status: action.payload.data.signatory.status,
                        isPrimarySignatory: true,
                    },
                    isBusinessVerified: action.payload.data.isBusinessVerified,
                },
            };
        case types.CREATE_WITH_ACC_INFO_FAILED:
            return {
                ...state,
                isCreatingAccStarted: false,
                isCreatingAccSuccess: false,
                isCreatingAccFailed: true,
                createAccErrorMsg: action.payload,
            };
        case types.CREATE_TRAN_PIN_STARTED:
            return {
                ...state,
                pinState: "loading",
            };
        case types.CREATE_TRAN_PIN_SUCEEDED:
            setState({
                ...getState(),
                isRequestingSignatoryPINSet: true,
            });
            return {
                ...state,
                pinState: "success",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    isRequestingSignatoryPINSet: true,
                },
            };
        case types.CREATE_TRAN_PIN_FAILED:
            return {
                ...state,
                pinState: "failed",
                pinErrorMesaage: action.payload,
            };
        case types.SELECT_SME_PROFILE:
            return {
                ...state,
                state: "filled",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    id: action.payload.data?.id,
                    customerId:
                        action.payload?.accounts?.customerId || action.payload.data?.customerId,
                    accountNumber: action.payload?.accounts?.accountNumber,
                    accountName: action.payload?.accounts?.accountName,
                    transactionPermission: action.payload?.accounts?.transactionPermission,
                    registeredBusinessName: action.payload?.data?.groupName,
                    businessNamePlaceholder:
                        action.payload?.data?.businessProfile?.businessNamePlaceholder,
                    sentBusinessOwnerConsentCount:
                        action.payload?.data?.businessProfile?.sentBusinessOwnerConsentCount,
                    businessOwnerCount: action.payload?.data?.businessProfile?.businessOwnerCount,
                    cacNumber: action.payload.data?.registrationNumber,
                    cacNumberPlaceholder:
                        action.payload?.data?.businessProfile?.cacNumberPlaceholder,
                    tinNumber: action.payload.data?.tinNumber,
                    dateOfRegistration: action.payload.data?.registrationDate,
                    industry: action.payload.data?.industrialSector,
                    primaryPhoneNumber: action.payload.data?.phoneNumber,
                    businessPhoneNumber: action.payload.data?.phoneNumber,
                    email: action.payload.data?.email,
                    websiteUrl: action.payload.businessProfile?.websiteUrl,
                    street: action.payload.data?.officialAddress,
                    lga: action.payload.data?.lga,
                    state: action.payload.data?.stateOfOperation,
                    city: action.payload.data?.lga,
                    country: action.payload.data?.countryOfOperation,
                    businessLogoFileUrl: action.payload.businessProfile?.businessLogoFileUrl,
                    certificateOfIncorperationFileUrl:
                        action.payload.businessProfile?.certificateOfIncorperationFileUrl,
                    memorandumAndArticlesOfAssociationFileUrl:
                        action.payload.businessProfile?.memorandumAndArticlesOfAssociationFileUrl,
                    particularsOfDirectorsFileUrl:
                        action.payload.businessProfile?.particularsOfDirectorsFileUrl,
                    particularsOfShareHoldersFileUrl:
                        action.payload.businessProfile?.particularsOfShareHoldersFileUrl,
                    boardResolutionFileUrl: action.payload.businessProfile?.boardResolutionFileUrl,
                    cacRegistrationFormFileUrl:
                        action.payload.businessProfile?.cacRegistrationFormFileUrl,
                    utilityBillFileUrl: action.payload.businessProfile?.utilityBillFileUrl,
                    businessCertificateFileUrl:
                        action.payload.businessProfile?.businessCertificateFileUrl,
                    isCacManualVerificationRequired:
                        action.payload.businessProfile?.isCacManualVerificationRequired,
                    isMigrated: false,
                    smeProfileStatus: action.payload.businessProfile?.smeProfileStatus,
                    businessCategory: action.payload.businessProfile?.businessCategory,
                    legalSearchChargeStatus:
                        action.payload.businessProfile?.legalSearchChargeStatus,
                    tradingName:
                        action.payload.businessProfile?.tradingName ||
                        action.payload.data?.groupName,
                    businessAge: action.payload.businessProfile?.businessAge,
                    industryType: action.payload.data?.industrialSector,
                    industryDescription: action.payload.data?.description,
                    landmark: action.payload.businessProfile?.landMark,
                    monthlyTurnOver: action.payload.businessProfile?.monthlyTurnOver,
                    numberOfTransactionsPerMonth:
                        action.payload.businessProfile?.numberOfTransactionsPerMonth,
                    website: action.payload.businessProfile?.websiteUrl,
                    countryOfIncoperation: action.payload.businessProfile?.countryOfOperation,
                    groupName: action.payload.data?.groupName,
                    groupType: action.payload.data?.groupType,
                    cacFileUploaded: action.payload.businessProfile?.cacFileUploaded,
                    //MISSING
                    //isPubliclyTraded: action.payload.businessProfile?.isPubliclyTraded,

                    dateOfIncorperation: action.payload.data?.incorporationDate,
                    isIndemnityFormAgreed: action.payload.businessProfile?.isIndemnityFormAgreed,
                    isBusinessProfileCompleted:
                        action.payload.businessProfile?.isBusinessProfileCompleted,
                    registrationPeriod: action.payload.businessProfile?.registrationPeriod,
                    isBusinessVerified: action.payload.businessProfile?.isBusinessVerified,
                    verificationRetryCount: action.payload.businessProfile?.verificationRetryCount,
                    directorRequired: action.payload.businessProfile?.directorRequired,
                    addressVerificationStatus:
                        action.payload.businessProfile?.addressVerificationStatus,
                    addressVerificationState:
                        action.payload.businessProfile?.addressVerificationState,
                    accountOpeningReason: action.payload.businessProfile?.accountOpeningReason,
                    // groupID and id are the same and are a replica for smeProfileId
                    groupID: action.payload.businessProfile?.groupID,
                    scumlBusinessType: action.payload.businessProfile?.scumlBusinessType,
                    isDirectorIndeminityAgreed:
                        action.payload.businessProfile?.isDirectorIndeminityAgreed,
                    businessInformation: action.payload.businessProfile?.businessInformation,
                    businessOwnerConsent: action.payload.businessProfile?.businessOwnerConsent,
                    signatoryAddress: action.payload.businessProfile?.signatoryAddress,
                    mayb: action.payload.businessProfile?.mayb,
                    additionalDocuments: action.payload.businessProfile?.additionalDocuments,
                    businessOwner: action.payload.businessProfile?.businessOwner,
                    isOnboardedOpenApi: action.payload.businessProfile?.isOnboardedOpenApi,
                    businessBvn: action.payload.data?.bvn,
                    signatory: {
                        ...state.singleSmeAccount.signatory,
                        accessLevel:
                            typeof action.payload.nominee?.accessLevel === "number"
                                ? action.payload.nominee?.accessLevel
                                : getValueFromEnum(action.payload.nominee?.accessLevel),
                        status:
                            typeof action.payload.nominee?.status === "string"
                                ? getIDFromEnum(action.payload.nominee?.status, signatoryStatusEnum)
                                : action.payload.nominee?.status,
                        role: action.payload.nominee?.role,
                        nomineeID: action.payload.nominee?.id,
                        userID: action.payload.nominee?.id,
                        tierLevel: action.payload?.accounts?.tierLevel,
                        isPinSet: action.payload.nominee?.isPinSet,
                        isTermsAgreed: action.payload.nominee?.isTermsAgreed,
                        singleApproverAmountLimit:
                            action.payload.nominee?.singleApproverAmountLimit,
                        singleTransferAmountLimit:
                            action.payload.nominee?.singleTransferAmountLimit,
                    },
                    docs: {
                        ...state.singleSmeAccount.docs,
                        CertificateOfIncorperation:
                            action.payload.businessProfile?.certificateOfIncorperationFileUrl,
                        MemorandumAndArticlesOfAssociation:
                            action.payload.businessProfile
                                ?.memorandumAndArticlesOfAssociationFileUrl,
                        ParticularsOfDirectors:
                            action.payload.businessProfile?.particularsOfDirectorsFileUrl,
                        ParticularsOfShareHolders:
                            action.payload.businessProfile?.particularsOfShareHoldersFileUrl,
                        BoardResolution: action.payload.businessProfile?.boardResolutionFileUrl,
                        CACRegistrationForm:
                            action.payload.businessProfile?.cacRegistrationFormFileUrl,
                        BusinessCertificate:
                            action.payload.businessProfile?.businessCertificateFileUrl,
                        UtilityBill: action.payload.businessProfile?.utilityBillFileUrl,
                        ScumlBusinessDocument:
                            action.payload.businessProfile?.scumlBusinessDocumentUrl,
                        TinCertificate: action.payload.businessProfile?.tinCertificateFileUrl,
                    },
                },
                rawData: {
                    ...state.rawData,
                    ...action.payload.raw,
                },
            };

        // case types.FETCH_SINGLE_SME_PROFILES_SUCCEEEDED: {
        //     return {
        //         ...state,
        //         singleSmeAccount: {
        //             ...state.singleSmeAccount,
        //             ...action.payload,
        //             signatory: {
        //                 ...action.payload.signatory,
        //                 accessLevel:
        //                     typeof action.payload.signatory?.accessLevel === "number"
        //                         ? action.payload.signatory?.accessLevel
        //                         : getValueFromEnum(action.payload.signatory?.accessLevel),
        //                 status:
        //                     typeof action.payload.signatory?.status === "string"
        //                         ? getIDFromEnum(
        //                               action.payload.signatory?.status,
        //                               signatoryStatusEnum,
        //                           )
        //                         : action.payload.signatory?.status,
        //             },
        //             docs: {
        //                 ...state.singleSmeAccount.docs,
        //                 CertificateOfIncorperation:
        //                     action.payload.certificateOfIncorperationFileUrl,
        //                 MemorandumAndArticlesOfAssociation:
        //                     action.payload.memorandumAndArticlesOfAssociationFileUrl,
        //                 ParticularsOfDirectors: action.payload.particularsOfDirectorsFileUrl,
        //                 ParticularsOfShareHolders: action.payload.particularsOfShareHoldersFileUrl,
        //                 BoardResolution: action.payload.boardResolutionFileUrl,
        //                 CACRegistrationForm: action.payload.cacRegistrationFormFileUrl,
        //             },
        //         },
        //     };
        // }

        case types.UPDATE_PIN_STATE:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    isRequestingSignatoryPINSet: true,
                },
            };

        case types.UPLOAD_LIMITED_DOCS_STARTED:
            return {
                ...state,
                limitedDocsState: "loading",
                loadingShowBar: true,
                failedShowBar: false,
                utilityBillUploadState: "loading",
            };
        case types.UPLOAD_LIMITED_DOCS_SUCEEDED:
            return {
                ...state,
                limitedDocsState: "success",
                loadingShowBar: false,
                failedShowBar: false,
                utilityBillUploadState: "success",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    docs: {
                        ...state.singleSmeAccount.docs,
                        [action.payload.name]: !action.payload.name
                            ? null
                            : action.payload.fileName,
                    },
                },
            };
        case types.UPLOAD_LIMITED_DOCS_FAILED:
            return {
                ...state,
                limitedDocsState: "failed",
                loadingShowBar: false,
                failedShowBar: true,
            };
        case types.CHANGE_PROFILE_PHOTO_STARTED:
            return {
                ...state,
                uploadPhotoState: "loading",
            };
        case types.CHANGE_PROFILE_PHOTO_SUCEEDED:
            setState({
                ...getState(),
                businessLogoFileUrl: action.payload,
            });
            return {
                ...state,
                uploadPhotoState: "success",
                profilePhoto: action.payload,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    businessLogoFileUrl: action.payload,
                },
            };
        case types.CHANGE_PROFILE_PHOTO_FAILED:
            return {
                ...state,
                uploadPhotoState: "failed",
            };
        case types.SET_INDUSTRY:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    industry: action.payload,
                },
            };
        case types.SET_SIGNATORY_DATA:
            return {
                ...state,
                singleSignatoryInfo: {
                    ...state.singleSignatoryInfo,
                    ...action.payload,
                },
            };
        case types.UPDATE_SIGNATORY_STARTED:
            return {
                ...state,
                updateSignatoryState: "loading",
            };
        case types.UPDATE_SIGNATORY_SUCCEEDED:
            // const itemIndex = state.signatoriesList.findIndex(
            //   (item) => item.id === action.payload.id
            // );
            // let updatedArr = [...state.signatoriesList];
            // updatedArr[itemIndex] = {
            //   ...updatedArr[itemIndex],
            //   firstName: action.payload.firstName,
            //   lastName: action.payload.lastName,
            //   designation: action.payload.designation,
            //   dateOfBirth: action.payload.dateOfBirth,
            //   phoneNumber: action.payload.phoneNumber,
            //   roleID: action.payload.roleID,
            //   status: action.payload.status,
            //   address: action.payload.address,
            //   id: action.payload.id,
            //   smeprofileid: action.payload.smeprofileid,
            //   userid: action.payload.userid,
            // };
            return {
                ...state,
                updateSignatoryState: "success",
                //signatoriesList: updatedArr,
            };
        case types.UPDATE_SIGNATORY_FAILED:
            return {
                ...state,
                updateSignatoryState: "failed",
            };
        case types.SET_COMPANY_DETAILS:
            setState({
                ...getState(),
                [action.payload.name]: !action.payload.name ? null : action.payload.value,
            });
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    [action.payload.name]: !action.payload.name ? null : action.payload.value,
                },
            };
        case types.CREATE_KUDA_ACCOUNT_STARTED:
            return {
                ...state,
                createKudaAccountState: "loading",
            };
        case types.CREATE_KUDA_ACCOUNT_SUCCEEDED:
            setState({
                ...getState(),
                accountNumber: action.payload.accountNumber,
                cacNumber: action.payload.data.cacNumber,
                registeredBusinessName: action.payload.data.registeredBusinessName,
                tinNumber: action.payload.data.tinNumber,
                dateOfRegistration: action.payload.data.dateOfRegistration,
                businessCategory: action.payload.data.businessCategory,
                email: action.payload.data.email,
                primaryPhoneNumber: action.payload.data.phoneNumber,
                street: action.payload.data.street,
                lga: action.payload.lga,
                docs: {
                    CertificateOfIncorperation: null,
                    MemorandumAndArticlesOfAssociation: null,
                    ParticularsOfDirectors: null,
                    ParticularsOfShareHolders: null,
                    boardResolutionFileUrl: "",
                },
                signatory: {
                    smeProfileID: action.payload.smeProfileID,
                    id: action.payload.signatoryID,
                    firstName: action.payload.data.signatory.firstName,
                    middleName: action.payload.data.signatory.middleName,
                    lastName: action.payload.data.signatory.lastName,
                    dateOfBirth: action.payload.data.signatory.dateOfBirth,
                    phoneNumber: action.payload.data.signatory.phoneNumber,
                    userID: action.payload.data.signatory.userID,
                    accessLevel: action.pasignatyload.data.signatory.accessLevel,
                    status: action.payload.data.signatory.status,
                    isPrimarySignatory: true,
                    address: action.payload.data.signatory.address,
                },
                businessLogoFileUrl: null,
                certificateOfIncorperationFileUrl: null,
                isMigrated: true,
                isRequestingSignatoryPINSet: false,
                memorandumAndArticlesOfAssociationFileUrl: null,
                particularsOfDirectorsFileUrl: null,
                particularsOfShareHoldersFileUrl: null,
                boardResolutionFileUrl: "",
                isBusinessVerified: action.payload.data.isBusinessVerified,
            });

            return {
                ...state,
                createKudaAccountState: "success",
                user: {
                    ...state.user,
                    smeProfileID: action.payload.smeProfileID,
                    signatoryID: action.payload.signatoryID,
                },
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    accountNumber: action.payload.accountNumber,
                    street: action.payload.data.street,
                    cacNumber: action.payload.data.cacNumber,
                    registeredBusinessName: action.payload.data.registeredBusinessName,
                    tinNumber: action.payload.data.tinNumber,
                    dateOfRegistration: action.payload.data.dateOfRegistration,
                    boardResolutionFileUrl: "",
                    businessCategory: action.payload.data.businessCategory,
                    businessLogoFileUrl: null,
                    certificateOfIncorperationFileUrl: null,
                    email: action.payload.data.email,
                    isMigrated: true,
                    isRequestingSignatoryPINSet: false,
                    lga: action.payload.lga,
                    memorandumAndArticlesOfAssociationFileUrl: null,
                    particularsOfDirectorsFileUrl: null,
                    particularsOfShareHoldersFileUrl: null,
                    primaryPhoneNumber: action.payload.data.phoneNumber,
                    signatory: {
                        smeProfileID: action.payload.smeProfileID,
                        id: action.payload.signatoryID,
                        firstName: action.payload.data.signatory.firstName,
                        middleName: action.payload.data.signatory.middleName,
                        lastName: action.payload.data.signatory.lastName,
                        dateOfBirth: action.payload.data.signatory.dateOfBirth,
                        phoneNumber: action.payload.data.signatory.phoneNumber,
                        userID: action.payload.data.signatory.userID,
                        accessLevel: action.payload.data.signatory.accessLevel,
                        status: action.payload.data.signatory.status,
                        isPrimarySignatory: true,
                    },
                    isBusinessVerified: action.payload.data.isBusinessVerified,
                },
            };
        case types.CREATE_KUDA_ACCOUNT_FAILED:
            return {
                ...state,
                createKudaAccountState: "failed",
            };
        case types.SET_SCUML_FILE:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    scumlDoc: action.payload,
                },
            };
        case types.APPROVE_INDEMNITY_LOADING:
            return {
                ...state,
                approveIndemnityLoading: true,
            };
        case types.APPROVE_INDEMNITY_SUCCEEDED:
            return {
                ...state,
                approveIndemnityLoading: false,
                approveIndemnityStatus: "success",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    isIndemnityFormAgreed: true,
                },
            };
        case types.APPROVE_LL_BN_INDEMNITY_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    directorRequired: false,
                },
            };

        case types.APPROVE_INDEMNITY_FAILED:
            return {
                ...state,
                approveIndemnityLoading: false,
                approveIndemnityStatus: "failed",
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    isIndemnityFormAgreed: false,
                },
            };
        case types.SHOW_INDEMNITY_ACCEPTED_MODAL:
            return {
                ...state,
                showIndemnityModal: true,
            };
        case types.CLOSE_INDEMNITY_ACCEPTED_MODAL:
            return {
                ...state,
                showIndemnityModal: false,
                approveIndemnityStatus: "idle",
            };
        case types.VALIDATE_USER_PHONENUMBER:
            return {
                ...state,
                validateUserPhoneNumber: action.payload,
            };
        case types.USER_PHONENUMBER_CHANGE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    user: {
                        ...state.singleSmeAccount.user,
                        phoneNumber: action.payload,
                    },
                },
            };
        case types.USER_INFO_UPDATE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    nextOfKin: {
                        firstName: action.payload.nokFirstName,
                        lastName: action.payload.nokLastName,
                        email: action.payload.nokEmail,
                        address: action.payload.nokAddress,
                        phoneNumber: action.payload.nokPhoneNumber,
                        relationship: action.payload.nokRelationship,
                    },
                },
            };
        case types.SET_USER_NOK_RELATIONSHIP:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    nextOfKin: {
                        ...state.singleSmeAccount.nextOfKin,
                        relationship: action.payload,
                    },
                },
            };
        case types.CHANGE_USER_PROFILE_PHOTO_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    user: {
                        ...state.singleSmeAccount.user,
                        profileImageFileUrl: action.payload,
                    },
                },
            };
        case types.VERIFY_BUSINESS_EMAIL_SUCCEEDED:
            return {
                ...state,
                validateBusinessEmail: action.payload.email,
            };
        case types.UPDATE_BUSINESS_EMAIL_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    email: action.payload.email,
                },
            };
        case types.SET_LOCAL_IP:
            return {
                ...state,
                localIpAddress: {
                    ...state.localIpAddress,
                    [action.payload.key]: action.payload.value,
                },
            };
        case types.SET_LOCAL_AUDIT_LOG:
            return {
                ...state,
                auditLogData: action.payload,
            };
        case types.UPDATE_BUSINESS_TYPE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    businessCategory: action.payload,
                },
            };
        case types.UPDATE_CAC_TIN_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    cacNumber: action.payload.cacNumber,
                    tinNumber: action.payload.tinNumber,
                    dateOfRegistration: action.payload.dateOfRegistration,
                },
            };
        case types.UPDATE_CHECKS:
            return {
                ...state,
                gettingStartedDashboardChecks: {
                    ...state.gettingStartedDashboardChecks,
                    ...action.payload,
                },
            };
        case types.PREFILL_LIMITED_DOCUMENTS:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    docs: {
                        ...state.singleSmeAccount.docs,
                        BoardResolution: action.payload,
                        CertificateOfIncorperation: action.payload,
                        MemorandumAndArticlesOfAssociation: action.payload,
                        ParticularsOfDirectors: action.payload,
                        ParticularsOfShareHolders: action.payload,
                    },
                },
            };
        case types.PREFILL_BUSINESS_DOCUMENTS:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    docs: {
                        ...state.singleSmeAccount.docs,
                        BusinessCertificate: action.payload,
                        CACRegistrationForm: action.payload,
                    },
                },
            };
        case types.USER_ADDRESS_UPDATE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    user: {
                        ...state.singleSmeAccount.user,
                        address: action.payload.street,
                        lga: action.payload.lga,
                        state: action.payload.state,
                        city: action.payload.lga,
                        country: action.payload.country,
                        landmark: action.payload.landmark,
                        street: action.payload.street,
                        utilityBillFileUrl: action.payload.utilityBillFileUrl,
                    },
                },
            };
        // TENTATIVE REDUCERS
        case types.SET_ACCOUNT_SELECTED_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    businessCategory: action.payload,
                    smeProfileStatus: 1,
                    isBusinessProfileCompleted: false,
                },
            };
        case types.SHOW_TRANSACTION_PIN_MODAL:
            return {
                ...state,
                showTransactionPinModal: true,
            };
        case types.SET_TERMS_STATUS:
            return {
                ...state,
                termsAgreed: true,
            };
        case types.UPDATE_BUSINESS_DETAILS_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    businessAge: action.payload.businessAge,
                    industryType: action.payload.industryType,
                    primaryPhoneNumber: action.payload.phoneNumber,
                    email: action.payload.email || state.singleSmeAccount.email,
                    industryDescription: action.payload.industrialSectorDescription,
                    websiteUrl: action.payload.websiteUrl,
                    monthlyTurnOver: action.payload.monthlyTurnOver,
                    numberOfTransactionsPerMonth: action.payload.numberOfTransactionsPerMonth,
                    website: action.payload.websiteUrl,
                    accountOpeningReason: action.payload.accountOpeningReason,
                    state: action.payload.stateOfOperation,
                    street: action.payload.officialAddress,
                    lga: action.payload.lga,
                    city: action.payload.lga,
                    landmark: action.payload.landMark,
                    scumlBusinessType: action.payload?.scumlBusinessType
                        ? action.payload?.scumlBusinessType
                        : "",
                },
            };
        case types.UPDATE_TIN_NUMBER_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    tinNumber: action.payload,
                },
            };
        case types.UPDATE_BUSINESS_NAME:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    businessNamePlaceholder: action.payload,
                },
            };
        case types.UPDATE_CAC_DOC:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    cacDone: true,
                },
            };
        case types.UPDATE_OTHER_DOC:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    businessDoc: true,
                },
            };
        case types.TRANSACTION_PIN_DONE:
            return {
                ...state,
                showTransactionPinModal: false,
            };
        // V2 REDUCERS
        case types.VALIDATE_TOKEN_AND_CREATE_SUCCEEDED:
            setState({
                ...getState(),
                id: action.payload.groups?.id,
                accountNumber: action.payload.accountNumber,
                registeredBusinessName: action.payload.groups?.groupName,
                cacNumber: action.payload.groups?.registrationNumber,
                tinNumber: action.payload.groups?.tinNumber,
                dateOfRegistration: action.payload.groups?.registrationDate,
                industry: action.payload.groups?.industrialSector,
                primaryPhoneNumber: action.payload.groups?.phoneNumber,
                email: action.payload.groups?.email,
                businessCategory: action.payload.businessProfile?.businessCategory,
                websiteUrl: action.payload.businessProfile?.websiteUrl,
                website: action.payload.businessProfile?.websiteUrl,
                country: action.payload.groups?.countryOfOperation,
                countryOfIncoperation: action.payload.businessProfile?.countryOfOperation,
                street: action.payload.groups?.officialAddress,
                lga: action.payload.groups?.lga,
                state: action.payload.groups?.stateOfOperation,
                city: action.payload.groups?.lga,
                cacRegistrationFormFileUrl:
                    action.payload.businessProfile?.cacRegistrationFormFileUrl,
                smeProfileStatus: action.payload.businessProfile?.smeProfileStatus,
                groupName: action.payload.groups?.groupName,
                groupType: action.payload.groups?.groupType,
                directorRequired: action.payload.businessProfile?.directorRequired,
                isIndemnityFormAgreed: action.payload.businessProfile?.isIndemnityFormAgreed,
                isBusinessProfileCompleted:
                    action.payload.businessProfile?.isBusinessProfileCompleted,
                isBusinessVerified: action.payload.businessProfile?.isBusinessVerified,
                verificationRetryCount: action.payload.businessProfile?.verificationRetryCount,
                addressVerificationStatus:
                    action.payload.businessProfile?.addressVerificationStatus,
                addressVerificationState: action.payload.businessProfile?.addressVerificationState,
                accountOpeningReason: action.payload.businessProfile?.accountOpeningReason,
                scumlBusinessType: action.payload.businessProfile?.scumlBusinessType,
                isDirectorIndeminityAgreed:
                    action.payload.businessProfile?.isDirectorIndeminityAgreed,
                kudaBusinessTier: action.payload.kudaBusinessTier,
                bvnStatus: action.payload.bvnStatus,
                idStatus: action.payload.idStatus,
                nerveID: action.payload.data?.id,
                restoreID: action.payload.data?.restoreID,
                gender: action.payload.data?.gender === 1 ? "Male" : "Female",
                creationDate: action.payload.data?.creationDate,
                passport: action.payload?.data?.passport,
                userPhotoLinkHash: action.payload?.data?.userPhotoLinkHash,
                docs: {
                    ...state.singleSmeAccount.docs,
                    CertificateOfIncorperation:
                        action.payload.businessProfile?.certificateOfIncorperationFileUrl,
                    MemorandumAndArticlesOfAssociation:
                        action.payload.businessProfile?.memorandumAndArticlesOfAssociationFileUrl,
                    ParticularsOfDirectors:
                        action.payload.businessProfile?.particularsOfDirectorsFileUrl,
                    ParticularsOfShareHolders:
                        action.payload.businessProfile?.particularsOfShareHoldersFileUrl,
                    BoardResolution: action.payload.businessProfile?.boardResolutionFileUrl,
                    CACRegistrationForm: action.payload.businessProfile?.cacRegistrationFormFileUrl,
                    BusinessCertificate: action.payload.businessProfile?.businessCertificateFileUrl,
                    UtilityBill: action.payload.businessProfile?.utilityBillFileUrl,
                    ScumlBusinessDocument: action.payload.businessProfile?.scumlBusinessDocumentUrl,
                },
                signatory: {
                    smeProfileID: action.payload.smeProfileID,
                    id: action.payload.signatoryID,
                    firstName: action.payload.data?.firstName,
                    middleName: action.payload.data?.firstName,
                    lastName: action.payload.data?.lastname,
                    dateOfBirth: action.payload.data?.dateOfBirth,
                    phoneNumber: action.payload.data?.phoneNumber,
                    userID: action.payload.data?.customerId,
                    accessLevel: action.payload.nominee?.accessLevel,
                    status: action.payload.nominee?.status,
                    nomineeID: action.payload.nominee?.id,
                    address: action.payload.data?.address,
                    tierLevel: action.payload?.tierLevel,
                    bvn: action.payload.data?.bvn,
                    isPinSet: action.payload.nominee?.isPinSet,
                    isTermsAgreed: action.payload.nominee?.isTermsAgreed,
                },
                user: {
                    ...state.singleSmeAccount.user,
                    docs: {
                        IdFront: action.payload.data.idDocumentFront,
                        IdBack: action.payload.data.idDocumentBack,
                    },
                },
                businessLogoFileUrl: null,
                certificateOfIncorperationFileUrl: null,
                isMigrated: true,
                isRequestingSignatoryPINSet: false,
                memorandumAndArticlesOfAssociationFileUrl: null,
                particularsOfDirectorsFileUrl: null,
                particularsOfShareHoldersFileUrl: null,
                boardResolutionFileUrl: "",
            });
            return {
                ...state,
                createKudaAccountState: "success",
                smeAccounts: action.payload.groups,
                user: {
                    ...state.user,
                    smeProfileID: action.payload.smeProfileID,
                    signatoryID: action.payload.signatoryID,
                },
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    id: action.payload.businessProfile?.groupID,
                    accountNumber: action.payload.accountNumber,
                    street: action.payload.groups?.officialAddress,
                    cacNumber: action.payload.groups?.cacNumber,
                    registeredBusinessName: action.payload.groups?.groupName,
                    tinNumber: action.payload.groups?.tinNumber,
                    dateOfRegistration: action.payload.groups?.dateOfRegistration,
                    boardResolutionFileUrl: "",
                    businessCategory: action.payload.businessProfile?.businessCategory,
                    businessAge: action.payload.businessProfile?.businessAge,
                    businessLogoFileUrl: null,
                    certificateOfIncorperationFileUrl: null,
                    email: action.payload.groups?.email,
                    isMigrated: true,
                    isRequestingSignatoryPINSet: false,
                    lga: action.payload.lga,
                    memorandumAndArticlesOfAssociationFileUrl: null,
                    particularsOfDirectorsFileUrl: null,
                    particularsOfShareHoldersFileUrl: null,
                    primaryPhoneNumber: action.payload.groups?.phoneNumber,
                    smeProfileStatus: action.payload.businessProfile?.smeProfileStatus,
                    groupID: action.payload.businessProfile?.groupID,
                    groupName: action.payload.groups?.groupName,
                    groupType: action.payload.groups?.groupType,
                    cacFileUploaded: action.payload.businessProfile?.cacFileUploaded,
                    isIndemnityFormAgreed: action.payload.businessProfile?.isIndemnityFormAgreed,
                    isBusinessProfileCompleted:
                        action.payload.businessProfile?.isBusinessProfileCompleted,
                    isBusinessVerified: action.payload.businessProfile?.isBusinessVerified,
                    verificationRetryCount: action.payload.businessProfile?.verificationRetryCount,
                    directorRequired: action.payload.businessProfile?.directorRequired,
                    addressVerificationStatus:
                        action.payload.businessProfile?.addressVerificationStatus,
                    addressVerificationState:
                        action.payload.businessProfile?.addressVerificationState,
                    accountOpeningReason: action.payload.businessProfile?.accountOpeningReason,
                    scumlBusinessType: action.payload.businessProfile?.scumlBusinessType,
                    isDirectorIndeminityAgreed:
                        action.payload.businessProfile?.isDirectorIndeminityAgreed,
                    kudaBusinessTier: action.payload.kudaBusinessTier,
                    bvnStatus: action.payload.bvnStatus,
                    idStatus: action.payload.idStatus,
                    nerveID: action.payload.data?.id,
                    restoreID: action.payload.data?.restoreID,
                    gender: action.payload.data?.gender === 1 ? "Male" : "Female",
                    creationDate: action.payload.data?.creationDate,
                    passport: action.payload?.data?.passport,
                    userPhotoLinkHash: action.payload?.data?.userPhotoLinkHash,
                    signatory: {
                        smeProfileID: action.payload.smeProfileID,
                        id: action.payload.signatoryID,
                        firstName: action.payload.data?.firstName,
                        middleName: action.payload.data?.otherNames,
                        lastName: action.payload.data?.lastname,
                        dateOfBirth: action.payload.data?.dateOfBirth,
                        phoneNumber: action.payload.data?.phoneNumber,
                        userID: action.payload.data?.customerId,
                        accessLevel: action.payload.nominee?.accessLevel,
                        status: action.payload.nominee?.status,
                        nomineeID: action.payload.nominee?.id,
                        isPrimarySignatory: true, //CHECK BACK with prince
                        isPinSet: action.payload.nominee?.isPinSet,
                        isTermsAgreed: action.payload.nominee?.isTermsAgreed,
                    },
                    docs: {
                        ...state.singleSmeAccount.docs,
                        CertificateOfIncorperation:
                            action.payload.businessProfile?.certificateOfIncorperationFileUrl,
                        MemorandumAndArticlesOfAssociation:
                            action.payload.businessProfile
                                ?.memorandumAndArticlesOfAssociationFileUrl,
                        ParticularsOfDirectors:
                            action.payload.businessProfile?.particularsOfDirectorsFileUrl,
                        ParticularsOfShareHolders:
                            action.payload.businessProfile?.particularsOfShareHoldersFileUrl,
                        BoardResolution: action.payload.businessProfile?.boardResolutionFileUrl,
                        CACRegistrationForm:
                            action.payload.businessProfile?.cacRegistrationFormFileUrl,
                        BusinessCertificate:
                            action.payload.businessProfile?.businessCertificateFileUrl,
                        UtilityBill: action.payload.businessProfile?.utilityBillFileUrl,
                        ScumlBusinessDocument:
                            action.payload.businessProfile?.scumlBusinessDocumentUrl,
                    },
                    user: {
                        ...state.singleSmeAccount.user,
                        docs: {
                            IdFront: action.payload.data.idDocumentFront,
                            IdBack: action.payload.data.idDocumentBack,
                        },
                    },
                },
            };
        case signuptypes.FETCH_SME_PROFILES_SUCCEEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    kudaBusinessTier: action.payload.kudaBusinessTier,
                    bvnStatus: action.payload.bvnStatus,
                    idStatus: action.payload.idStatus,
                    nerveID: action.payload.id,
                    restoreID: action.payload.restoreID,
                    gender: action.payload?.gender === 1 ? "Male" : "Female",
                    customerCategory: action.payload.customerCategory,
                    creationDate: action.payload?.creationDate,
                    passport: action.payload?.passport,
                    userPhotoLinkHash: action.payload?.userPhotoLinkHash,
                    signatory: {
                        ...state.singleSmeAccount.signatory,
                        id: action.payload.customerId,
                        firstName: action.payload.firstName,
                        middleName: action.payload.otherNames,
                        lastName: action.payload.lastname,
                        gender: action.payload.gender,
                        dateOfBirth: action.payload.dateOfBirth,
                        bvn: action.payload.bvn,
                        userID: action.payload.customerId,
                        profileImageFileUrl: action.payload.passport,
                        email: action.payload.email,
                        phoneNumber: action.payload.phoneNumber,
                        address: action.payload.address,
                        city: action.payload.lga,
                        state: action.payload.state,
                        country: action.payload.nationality,
                        isPoliticallyExposed: action.payload.politicallyExposed,
                        //utilityBillFileUrl: action.payload.data.
                        //signatoryStatus: action.payload.data.
                    },
                    nextOfKin: {
                        ...state.singleSmeAccount.nextOfKin,
                        firstName: action.payload?.nokName?.split(" ")?.[0],
                        lastName: action.payload?.nokName?.split(" ")?.[1],
                        email: action.payload.nokEmail,
                        address: action.payload.nokAddress,
                        phoneNumber: action.payload.nokPhoneNumber,
                        relationship: action.payload.nokRelationship,
                    },
                    user: {
                        ...state.singleSmeAccount.user,
                        id: action.payload.customerId,
                        firstName: action.payload.firstName,
                        middleName: action.payload.otherNames,
                        lastName: action.payload.lastname,
                        gender: action.payload.gender,
                        dateOfBirth: action.payload.dateOfBirth,
                        bvn: action.payload.bvn,
                        userID: action.payload.customerId,
                        profileImageFileUrl: action.payload.passport,
                        email: action.payload.email,
                        phoneNumber: action.payload.phoneNumber,
                        address: action.payload.address,
                        city: action.payload.lga,
                        state: action.payload.state,
                        country: action.payload.nationality,
                        isPoliticallyExposed: action.payload.politicallyExposed,
                        docs: {
                            IdFront: action.payload.idDocumentFront,
                            IdBack: action.payload.idDocumentBack,
                        },
                    },
                },
            };
        case types.UPDATE_CACDOCSTATE_UPDATE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    cacFileUploaded: action.payload.cacFileUploaded,
                },
            };
        case types.CLOSE_START_BANKING_MODAL:
            return {
                ...state,
                showStartBankingModal: false,
            };
        case types.CREATE_PIN_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    signatory: {
                        ...state.singleSmeAccount.signatory,
                        isPinSet: true,
                    },
                },
            };
        case types.APPROVE_TERMS_SUCCEEDED:
            return {
                ...state,
                showStartBankingModal: true,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    signatory: {
                        ...state.singleSmeAccount.signatory,
                        isTermsAgreed: true,
                    },
                },
            };
        case types.IS_DIRECTOR_REQUIRED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    directorRequired: true,
                },
            };
        case types.UPDATE_IS_DIRECTOR_INDEMNITY_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    isDirectorIndeminityAgreed: true,
                },
            };
        case types.USER_NOK_INFO_UPDATE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    nextOfKin: action.payload.nextOfKin,
                },
            };
        case types.BVN_DOC_FLAG_UPDATE_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    ...action.payload,
                },
            };
        case types.UPLOAD_VALID_ID_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    user: {
                        ...state.singleSmeAccount.user,
                        docs: {
                            ...state.singleSmeAccount.user.docs,
                            [action.payload.name]: action.payload.data,
                        },
                    },
                },
            };
        case types.UPDATE_KUDA_BUSINESS_TIER:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    kudaBusinessTier: 3,
                },
            };

        case types.UPDATE_LEGAL_SEARCH_CHARGE_STATUS:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    legalSearchChargeStatus: action.payload,
                },
            };
        case types.CREATE_BUSINESS_ACCOUNT_SUCCEEDED:
            return {
                ...state,
                singleSmeAccount: {
                    ...state.singleSmeAccount,
                    accountNumber: action.payload,
                },
            };
        default:
            return state;
    }
};
